<template>
    <div class="dap-grid" :style="gridStyle">
        <div v-for="(item, index) in dataList" :key="index" :style="gridItemStyle">
            <slot :item="item" :index="index"></slot>
        </div>
        <!-- 解决数据过少时，拉伸过宽的问题 -->
        <div 
            v-for="(emptyItem, emptyIdx) in new Array(10)" 
            :key="`empty-${emptyIdx}`">
        </div>
    </div>
</template>

<script>
export default {
    name: 'DapGrid',
    props: {
        min: {
            type: String,
            default: '210px',
        },
        max: {
            type: String,
            default: '1fr',
        },
        columnGap: {
            type: String,
            default: '20px',
        },
        rowGap: {
            type: String,
            default: '20px',
        },
        dataList: { 
            type: Array,
            default: () => [],
        }
    },
    data () {
        return {};
    },
    computed: {
        gridStyle () {
            return {
                'grid-template-columns': `repeat(auto-fit, minmax(${this.min}, ${this.max}))`,
                'grid-column-gap': this.columnGap,
                // 'grid-row-gap': this.rowGap,
            };
        },
        gridItemStyle () {
            return {
                'margin-bottom': this.rowGap,
            };
        },
    },
};
</script>

<style lang="scss">
.dap-grid {
    display: grid;
    // grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    // grid-column-gap: 20px;
}
</style>